import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnlineApplicationRoutingModule } from './online-application-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OnlineApplicationComponent } from './online-application/online-application.component';
import { NgxMaskModule } from 'ngx-mask'
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { NgSelectModule } from '@ng-select/ng-select';
import { environment } from 'src/environments/environment';
import { OnlineApplicationConfirmationComponent } from './online-application-confirmation/online-application-confirmation.component';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [
    OnlineApplicationComponent,
    OnlineApplicationConfirmationComponent
  ],
  imports: [
    CommonModule,
    OnlineApplicationRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxMaskModule.forRoot(),
    RecaptchaV3Module,
    NgSelectModule,
    NgxSpinnerModule
  ],
  providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.RECAPTCHA_V3_SITE_KEY }]
})
export class OnlineApplicationModule { }
